import { render, staticRenderFns } from "./EvaluacionRegistra.vue?vue&type=template&id=7fe3d2fe&"
import script from "./EvaluacionRegistra.vue?vue&type=script&lang=js&"
export * from "./EvaluacionRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports